module.exports = new __parcel__URL__("browser1.6557a92d.png").toString();